import React from 'react';
import { Bell, Mail, Smartphone } from 'lucide-react';

const NotificationsSettings = () => {
  const notifications = [
    {
      title: 'Order Updates',
      description: 'Order confirmations, shipping updates, delivery notifications',
      icon: Bell,
      channels: {
        email: true,
        push: true,
        sms: false
      }
    },
    {
      title: 'Promotions & Offers',
      description: 'Discounts, special offers, and new arrivals',
      icon: Mail,
      channels: {
        email: true,
        push: true,
        sms: true
      }
    },
    {
      title: 'Account Activity',
      description: 'Login alerts, password changes, security updates',
      icon: Smartphone,
      channels: {
        email: true,
        push: true,
        sms: true
      }
    }
  ];

  return (
    <div className="p-6">
      <div className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900">Notifications</h2>
        <p className="text-gray-600 mt-1">
          Choose how you want to be notified about your account activity
        </p>
      </div>

      <div className="space-y-6">
        {notifications.map((notification, index) => (
          <div key={index} className="border border-gray-200 rounded-lg p-6">
            <div className="flex items-start justify-between">
              <div className="flex items-start space-x-4">
                <div className="p-2 bg-primary-50 rounded-lg">
                  <notification.icon className="h-6 w-6 text-primary-600" />
                </div>
                <div>
                  <h3 className="font-medium text-gray-900">{notification.title}</h3>
                  <p className="text-sm text-gray-500 mt-1">{notification.description}</p>
                </div>
              </div>
            </div>

            <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id={`email-${index}`}
                  checked={notification.channels.email}
                  className="h-4 w-4 text-primary-600 rounded"
                  onChange={() => {}}
                />
                <label htmlFor={`email-${index}`} className="ml-3 text-sm text-gray-700">
                  Email
                </label>
              </div>
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id={`push-${index}`}
                  checked={notification.channels.push}
                  className="h-4 w-4 text-primary-600 rounded"
                  onChange={() => {}}
                />
                <label htmlFor={`push-${index}`} className="ml-3 text-sm text-gray-700">
                  Push Notifications
                </label>
              </div>
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id={`sms-${index}`}
                  checked={notification.channels.sms}
                  className="h-4 w-4 text-primary-600 rounded"
                  onChange={() => {}}
                />
                <label htmlFor={`sms-${index}`} className="ml-3 text-sm text-gray-700">
                  SMS/WhatsApp
                </label>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-8 flex justify-end">
        <button className="px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700">
          Save Preferences
        </button>
      </div>
    </div>
  );
};

export default NotificationsSettings;